import api from './api.js';
import { TagSelector } from './script/tag/tag-selector';

api.tag = {
  TagSelector: TagSelector
};

export default api;
